import { types, actions } from './requests'
export const GETWORKLISTFORDAE_TYPES = {
    ...types('GETWORKLISTFORDAE'),
}
export const GETWORKLISTFORDAE_ACTIONS = {
    ...actions('GETWORKLISTFORDAE'),
}
